.box {
  padding: 15px;
  text-align: center;
}

.box a:hover {
  text-decoration: underline;
}

.box3 {
  width: 400px;
}

.box4 {
  width: 300px;
}

.box-container {
  display: flex;
}

.yellow {
  background-color: #f1e500;
}

.gray {
  background-color: #b1b1b1;
}

.gray-light {
  background-color: #d8d8d8;
}

.gray-dark {
  background-color: #777;
  color: white;
}

.auto-width {
  margin: auto;
}

.bold {
  font-weight: 700;
}
